export const GET_ALL_PAYMENT_LOGS = 'GET_ALL_PAYMENT_LOGS'
export const GET_ALL_REFUND_LOGS = 'GET_ALL_REFUND_LOGS'
export const GET_ALL_MEMBERSHIP_LOGS = 'GET_ALL_MEMBERSHIP_LOGS'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
